var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('span',{staticClass:"headline mb-0"},[_vm._v("用户注册")])]),_c('v-card-text',[_c('h3',[_vm._v("处理Point")]),_c('ol',[_c('li')])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }